import { styled } from '@linaria/react';
export const SafetyAccordionWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.25rem;
`;

export const InfoBoxWrapper = styled.div`
    flex: 0 0 68%;
    display: flex;
    gap: 0.75rem;

    @media (max-width: 1024px) {
        flex: 0 0 100%;
    }

    @media (max-width: 768px) {
        gap: 0.35rem;
    }
`;

export const InfoBox = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

const InfoBoxContentBase = styled.div`
    border-radius: 4px;
    padding: 5px;
    position: relative;

    h2 {
        font-size: 1.25rem;
        text-align: center;
        margin: 0 0 0.5rem 0;
        font-weight: 400;
    }

    h3 {
        font-size: 2.7rem;
        margin: 0;
        text-align: center;
        font-weight: 400;
        color: #000;
    }

    h4 {
        font-size: 1.25rem;
        font-weight: 400;
        text-align: center;
        padding: 0.125rem 0.5rem;
    }

    h5 {
        color: #6d0a0a;
        padding: 0 0.625rem;
        font-size: 0.813rem;
        font-weight: 400;
    }

    @media (max-width: 768px) {
        padding: 3px;
        height: 9rem;

        h2 {
            font-size: 0.85rem;
            margin: 0 0 0.25rem 0;
        }

        h3 {
            font-size: 1.8rem;
        }

        h4 {
            font-size: 0.8rem;
            padding: 0.1rem 0.25rem;
        }

        h5 {
            font-size: 0.7rem;
            padding: 0 0.375rem;
        }
    }
`;

export const InfoBoxContentNormal = styled(InfoBoxContentBase)`
    background: #d5f1c6;
    border: 1px solid #bcd8ad;  
   
    h2, h4 {
        color: #1b4c00;
    }
`;

export const InfoBoxContentHigh = styled(InfoBoxContentBase)`
    background: #fde3b5;
    border: 1px solid #ffce75;

    h2, h4 {
        color: #422b03;
    }
`;

export const InfoBoxContentExtreme = styled(InfoBoxContentBase)`
    background: #f99d9d;
    border: 1px solid #ff8d8d;

    h2, h4 {
        color: #6d0a0a;
    }
`;

export const LevelNumberBox = styled.div`
    text-align: center;
    margin: 0.5rem 0;
`;

export const LevelNumber = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
`;

export const InfoTextContent = styled.div`
    background: #f4f4f4;
    border: 1px solid #ddd;
    border-radius: 4px;
    min-height: 250px;
    padding: 0.5rem;

    h5 {
        color: #6d0a0a;
        font-size: 0.813rem;
        margin: 0 0 0.5rem 0;
        text-align: center;
        line-height: 1.3em;
        border-radius: 5px 0 0 0;
        font-weight: 400;
    }

    ul {
        list-style: disc;
        padding: 0.5rem;
        margin: 0 0 0 1rem;
        
        li {
            margin-bottom: 0.5rem;
            line-height: 1.4;
            font-size: 0.75rem;
            list-style: disc;
        }
    }

    @media (max-width: 768px) {
        min-height: auto;
        padding: 0.375rem;
        height: 10.5rem;

        h5 {
            font-size: 0.7rem;
            margin: 0 0 0.25rem 0;
        }

        ul {
            padding: 0.25rem;
            margin: 0 0 0 0.75rem;

            li {
                font-size: 0.65rem;
                margin-bottom: 0.25rem;
                line-height: 1.3;
            }
        }
    }
`;

export const DescTextContent = styled.div`
    background: #f4f4f4;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0.5rem;

    h5 {
        cursor: pointer;
        font-size: 0.7rem;
        padding: 0.15rem;
        margin: 0;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:hover {
            background: #e9ecef;
        }

        a {
            color: #543204;
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            
            i {
                display: inline-block;
                transition: transform 0.2s ease;
                
                &::before {
                    content: '▶';
                    font-style: normal;
                    font-size: 0.75rem;
                }
                
                &.open {
                    transform: rotate(90deg);
                }
            }
        }
    }

    ul {
        list-style: disc;
        padding: 0 0 0 1.25rem;
        margin: 0 0 0 1.25rem;
        
        li {
            margin-bottom: 0.5rem;
            line-height: 1.4;
            font-size: 0.875rem;
        }
    }

    @media (max-width: 768px) {
        padding: 0.375rem;

        h5 {
            font-size: 0.6rem;

            a i::before {
                font-size: 0.6rem;
            }
        }

        ul li {
            font-size: 0.7rem;
            margin-bottom: 0.25rem;
            line-height: 1.3;
        }
    }
`;

export const DetailsColumn = styled.div`
    margin: 3px 0 0 10px;
    flex: 0 0 29%;
    max-width: 29%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    @media (max-width: 1024px) {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .edit-select {
        width: 100%;
        max-width: 100%;
        height: auto;
        line-height: normal;
        background: #f4f4f4;
        padding: 7px;
        margin: 8px 0px;
    }
`;

export const HazardList = styled.ul`
    list-style: none;
    color: #444;
    padding: 0;
    background: #f4f4f4;
    width: 100%;
    max-width: 100%;
    border: 1px solid #dedede;
    border-radius: 4px;
    overflow: hidden;
`;

export const HazardItem = styled.li`
    display: grid;
    grid-template-columns: 60px 1fr;
    align-items: center;
    width: 100%;
    padding: 0.25rem 0;
    border-bottom: 1px solid #e9ecef;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #e9ecef;
    }
    
    &.edit-mode {
        grid-template-columns: 30px 60px 1fr;
    }
`;

export const HazardCode = styled.span`
    font-weight: 600;
    border-right: 1px solid #ddd;
    padding: 0.313rem 0.625rem;
    font-size: 0.813rem;
    text-align: center;
`;

export const HazardDescription = styled.span`
    padding: 0.313rem 0.625rem;
    font-size: 0.813rem;
`;

export const ExposureLevelBadge = styled.span<{ level: number }>`
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 3px;
    font-size: 0.75rem;
    font-weight: 600;
    margin-left: 0.5rem;

    ${(props) => {
        if (props.level <= 1) {
            return `
                background: #d5f1c6;
                color: #1b4c00;
            `;
        } else if (props.level === 2) {
            return `
                background: #fde3b5;
                color: #422b03;
            `;
        } else {
            return `
                background: #f99d9d;
                color: #6d0a0a;
            `;
        }
    }}
`;

export const ImageWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    justify-content: start;
    margin-top: 1rem;

    span {
        display: inline-block;
        cursor: help;

        img {
            display: inline-block;
            margin: 0 5px 0 0;
            max-width: 35px;
            object-fit: contain;
            transition: transform 0.2s;

            &:hover {
                transform: scale(1.1);
            }
        }
    }
`;

export const ChangedManuallyMessage = styled.span`
    display: block;
    font-style: italic;
    color: #856404;
    background: #fff3cd;
    padding: 0.5rem 1rem;
    border-left: 4px solid #ffc107;
    margin-top: 1rem;
    font-size: 0.875rem;
`;

export const NAMessage = styled.span`
    display: block;
    font-style: italic;
    color: #721c24;
    background: #f8d7da;
    padding: 0.5rem 1rem;
    border-left: 4px solid #dc3545;
    margin-top: 1rem;
    font-size: 0.875rem;
`;

export const CommentsSection = styled.div`
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid #dee2e6;
`;

export const CommentsLabel = styled.label`
    display: block;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
`;

export const CommentsText = styled.pre`
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
    font-size: 0.875rem;
    color: #333;
    margin: 0;
    line-height: 1.6;
    background: #f8f9fa;
    padding: 0.75rem;
    border-radius: 4px;
    border: 1px solid #dee2e6;
`;

export const EmergencyProcedureRemoveButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 0.875rem;
    padding: 0.25rem;
    opacity: 0.6;
    transition: opacity 0.2s;
    color: #dc3545;

    &:hover {
        opacity: 1;
    }
`;

export const AddEmergencyProcedureWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
`;

export const EmergencyScenariosTable = styled.table`
    width: 100%;
    margin-top: 1rem;
    border-collapse: collapse;
    border: 1px solid #dee2e6;

    thead {
        background: rgb(238 238 238);
        border-bottom: 2px solid #dee2e6;

        th {
            padding: 0.75rem;
            text-align: left;
            font-weight: 700;
            color: #495057;
            font-size: 0.875rem;
        }
    }

    tbody {
        tr {
            border-bottom: 1px solid #dee2e6;

            &:hover {
                background: #f8f9fa;
            }

            td {
                padding: 0.75rem;
                font-size: 0.875rem;
                color: #333;
                vertical-align: top;

                &.procedure-title {
                    width: 30%;
                    font-weight: 500;
                }
            }
        }
    }

    .full-width-item {
        grid-column: 1 / -1;
    }
`;

export const DraegerTubesList = styled.div`
    display: inline;
`;

export const DraegerTubeLink = styled.a`
    color: #007bff;
    text-decoration: none;
    font-size: 0.875rem;

    &:hover {
        text-decoration: underline;
        color: #0056b3;
    }
`;

export const ExternalLink = styled.a`
    color: #0066cc;
    text-decoration: underline;
    font-weight: 500;
    font-size: 0.875rem;

    &:hover {
        text-decoration: underline;
        color: #004d99;
    }
`;

// Edit Mode Styles
export const EditModeOverwriteSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    padding: 0.5rem;
`;

export const GeneratedValueLabel = styled.h6`
    font-size: 0.75rem;
    font-weight: 400;
    margin: 0;
    text-align: center;
    color: #333;
    
    span {
        display: block;
        font-size: 1.5rem;
        font-weight: 600;
        margin-top: 0.25rem;
    }
`;

export const OverwriteLabel = styled.h6`
    font-size: 0.75rem;
    font-weight: 400;
    margin: 0.5rem 0 0.25rem 0;
    text-align: center;
    color: #333;
`;

export const OverwriteInput = styled.input`
    width: 60px;
    padding: 0.375rem 0.5rem;
    font-size: 1rem;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: linear-gradient(to bottom, #f8f9fa, #e9ecef);
    
    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
    
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    
    -moz-appearance: textfield;
`;

export const HazardSelect = styled.select`
    width: 100%;
    padding: 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #f4f4f4;
    margin-bottom: 0.5rem;
    cursor: pointer;
    
    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
`;

export const HazardRemoveButton = styled.button`
    display: table-cell;
    width: 30px;
    padding: 0.25rem;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 0.875rem;
    vertical-align: middle;
    text-align: center;
    opacity: 0.6;
    transition: opacity 0.2s;
    
    &:hover {
        opacity: 1;
    }
`;

export const EditSelect = styled.select`
    padding: 0.375rem 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: linear-gradient(to bottom, #f8f9fa, #e9ecef);
    cursor: pointer;
    min-width: 120px;
    
    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
`;

export const EditInput = styled.input`
    padding: 0.375rem 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: linear-gradient(to bottom, #f8f9fa, #e9ecef);
    width: 80px;
    
    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
    
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    
    -moz-appearance: textfield;
`;

export const EditTextarea = styled.textarea`
    width: 100%;
    min-height: 80px;
    padding: 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #ffffff;
    resize: vertical;
    font-family: inherit;
    
    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
`;

export const EditFieldWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const InputSuffix = styled.span`
    font-size: 0.875rem;
    color: #666;
`;

export const DraegerTubeItem = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    
    &.edit-mode {
        background: #f4f4f4;
        padding: 0.25rem 0.5rem;
        border-radius: 4px;
        border: 1px solid #ddd;
    }
`;

export const DraegerTubeRemoveButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 0.75rem;
    line-height: 1;
    margin-left: 0.25rem;
    
    &:hover {
        background: #c82333;
    }
`;

export const AddDraegerTubeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
`;

export const CommentsEditSection = styled.div`
    margin-top: 1rem;
    padding: 1rem;
    background: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 4px;
`;

export const CommentsEditLabel = styled.label`
    display: block;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
`;

export const StackedInfoSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 2rem;
`;

export const MsdsLinkWrapper = styled.div`
    margin-bottom: 1rem;
`;
